/* tslint:disable */
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EventEmitter, Inject, Injectable, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, first, firstValueFrom, Subject, Subscription} from 'rxjs';
import {CustomValidatorFn, DynamicFormConfig, DynamicFormReadyEvent, DynamicFormService, FieldTypeEnum, FilterSelectFieldConfig} from '@mydocma/dynamic-form';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {FieldMinimal} from '@docma-mm-core/field/field';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {FaultFieldGroups} from '../fault-field-groups';
import {MmFaultFormService} from '../../mm-fault-form.service';
import {FaultFieldTypeEnum} from '../fault-field-type.enum';
import {FieldConfig} from '@mydocma/dynamic-form/lib/dynamic-field/field.config';
import {filter, map, switchMap, take, tap} from 'rxjs/operators';
import {FaultField} from '../fault-field';
import {FieldPropertyEnum} from '@docma-mm-core/field/field-property.enum';
import {MmProjectPermissionsService} from '../../../../mm-project/mm-project-permissions-service';
import {FieldPermission} from '@docma-mm-core/field/field-permission.enum';
import {PlanEditModeEnum} from '../../../mm-plans-view/mm-plan-view/services/plan-edit-mode.enum';
import {FaultViewEnum, MmFaultViewService} from '../../mm-fault-view.service';
import {MmPlanEditService} from '../../../mm-plans-view/mm-plan-view/services/mm-plan-edit.service';
import {MmPlansManagerService} from '../../../mm-plans-view/services/mm-plans-manager.service';
import {ProjectActionPermissionEnum} from '@docma-mm-core/permission/project-action-permission.enum';
import {FieldDefaultNameEnum} from '@docma-mm-core/field/field-default-name.enum';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {SyncState} from '@docma-mm-core/model/sync-state/sync-state';
import {CustomValidationError} from '@mydocma/dynamic-form/lib/validation/custom-validation-error';
import {MmContactService} from './mm-contact.service';
import {MmFaultFieldService} from '../../services/mm-fault-field.service';
import {MmProjectLoaderService} from '../../../../mm-project/mm-project-loader.service';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {ViewPoint} from '@docma-mm-core/status/viewpoint.enum';
import {MmCompanyService} from './mm-company.service';
import {MmCraftService} from './mm-craft.service';
import {MmOrderService} from './mm-order.service';
import {MmCompanyDependencyService, NotificationSenderEnum} from './mm-company-dependency.service';
import {TranslateService} from '@ngx-translate/core';
import {PersonalizationKeysEnum} from '@docma-mm-core/personalization/personalization-keys.enum';
import {FieldHint} from '@mydocma/dynamic-form/lib/hint-text/field-hint';
import {FieldConfig as FaultFieldConfig} from '@docma-mm-core/field-config/field-config';
import {clearDictionary} from '@docma-mm-core/utils/utils';
import {MmViewService} from '../../../../mm-view.service';
import {MmFaultFieldMemoryService} from './mm-fault-field-memory.service';
import {MmFilterService} from '../../../../mm-filter/mm-filter.service';
import {flattenStructure, Structure} from '@docma-mm-core/structure/structure';
import moment from 'moment';
import {MmFaultsSyncService} from '../../../mm-faults-sync-service';
import {MmAttributeService} from './mm-attribute.service';
import {FaultDependencyEnum} from './fault-dependency-enum';
import {FieldService} from '@docma-mm-core/field/field.service';
import {UserDefineds} from '@docma-mm-core/user-defined/user-defined';
import {Company} from '@docma-mm-core/company/company';
import {Order} from '@docma-mm-core/order/order';
import {Craft} from '@docma-mm-core/craft/craft';
import {Classifications} from '@docma-mm-core/classification/classification';
import {MmBimDialogService} from '../../../../mm-bim/mm-bim-view/bim-dialog/bim-dialog.service';
import {BpPinLocationTargetEnum} from '../../../../bp-common/models/bp-pin';
import {MmProjectService} from '../../../../mm-project/mm-project.service';
import {MmPlanViewService} from '../../../mm-plans-view/mm-plan-view/services/mm-plan-view.service';
import {MydocmaPromptButtonTypeEnum, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {Pool} from '@docma-mm-core/pool/pool';
import {PoolApiService} from '../../../../mm-filter/pool/services/pool-api.service';
import {PoolFaultTrackerService} from '../../../../mm-filter/pool/services/pool-fault-tracker.service';
import {MmFaultsLoaderService} from '../../../mm-faults-loader.service';
import {ErrorService} from '../../../mm-error.service';
import {MmFaultPinService} from '../../services/mm-fault-pin.service';
import {Logger} from '@mydocma/common/src/lib/logger';
import { SyncStateChange } from '@docma-mm-core/fault/sync/fault-sync.service';

@UntilDestroy()
@Injectable()
export class MmFaultDetailsService implements OnInit, OnDestroy {

  constructor(private faultFormService: MmFaultFormService,
              private readonly permissionService: MmProjectPermissionsService,
              public readonly planEditService: MmPlanEditService,
              public readonly plansManagerService: MmPlansManagerService,
              private readonly viewService: MmFaultViewService,
              private faultFieldService: MmFaultFieldService,
              public readonly projectLoaderService: MmProjectLoaderService,
              private mmProjectService: MmProjectService,
              @Inject(FieldPropertyEnum.ContactCO) private contactServiceCO: MmContactService,
              @Inject(FieldPropertyEnum.ContactCT) private contactServiceCT: MmContactService,
              @Inject(FieldPropertyEnum.ContactSC) private contactServiceSC: MmContactService,
              private readonly companyDependencyService: MmCompanyDependencyService,
              private readonly companyService: MmCompanyService,
              private readonly craftService: MmCraftService,
              private readonly orderService: MmOrderService,
              private readonly attributeService: MmAttributeService,
              private readonly faultFieldMemoryService: MmFaultFieldMemoryService,
              private readonly mmViewService: MmViewService,
              private readonly filterService: MmFilterService,
              private readonly faultsSyncService: MmFaultsSyncService,
              private readonly translateService: TranslateService,
              private readonly fieldService: FieldService,
              private mmPlanViewService: MmPlanViewService,
              private readonly bimDialogService: MmBimDialogService,
              private readonly dialogService: PromptDialogService,
              private readonly notificationService: NotificationService,
              private readonly poolApiService: PoolApiService,
              private readonly faultsLoaderService: MmFaultsLoaderService,
              private readonly errorService: ErrorService,
              private readonly faultPinService: MmFaultPinService,
              private readonly poolFaultTracker: PoolFaultTrackerService,
              private readonly logger: Logger) {

    this.faultFieldService.structures$
      .pipe(
        tap(s => this.loadedStructures = s),
        untilDestroyed(this)
      )
      .subscribe(changes => {
      });

    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(async lang => {

        await Promise.all([FieldPropertyEnum.Company, FieldPropertyEnum.Craft, FieldPropertyEnum.Order].map(async prop => {
          if (this.fieldConfigsDict.hasOwnProperty(prop)) {
            await this.updateInfoMessageConfig(prop);
          }
        }));

        if (!!this.formReadyEvent?.dynamicFormService) {
          const structurePathConfig = this.formReadyEvent.dynamicFormService.getFieldConfig('StructurePath');
          structurePathConfig.label.text = `${this.allFields[FieldPropertyEnum.Structure].Name} ${this.translateService.instant('MM.fault.structurePathSuffix')}`;
          this.formReadyEvent.dynamicFormService.updateFieldConfig(structurePathConfig);
        }
      });

    this.faultsLoaderService.setShouldHideFaultCallback((fault: ViewFault) => {
      if (!fault?.uid || !this.fault?.uid) {
        return false;
      }

      const isCurrentFault = this.fault.uid === fault.uid;
      const shouldHide = isCurrentFault && this.shouldHideFaultFromView.get(fault.uid);

      return shouldHide || false;
    });

    this.faultsSyncService.onNewFaultSynced
      .pipe(untilDestroyed(this))
      .subscribe(async syncedFault => {
        if (syncedFault?.uid && this?.faultData?.UniqueId && syncedFault.uid === this?.faultData?.UniqueId) {
          if (syncedFault.data.Number1 && !this.faultData.Number1) {
            this.faultData.Number1 = syncedFault.data.Number1;
            const project = await firstValueFrom(this.mmProjectService.currentProject);
            if (
              project?.textPinEnabled
              && project?.textPinFieldId
              && await this.faultPinService.getPinTextValue({[FieldPropertyEnum.Number1]: syncedFault.data.Number1})
            ) {
              syncedFault.pinText = syncedFault.data.Number1 + '';

            }
            this.formReadyEvent.dynamicFormService.updateFieldValue(FieldPropertyEnum.Number1, syncedFault.data.Number1);
          }

          if (syncedFault.id !== this.faultData.Id) {
            this.faultData.Id = syncedFault.id;
          }

          if (syncedFault.data.Number2 !== this.faultData.Number2) {
            this.faultData.Number2 = syncedFault.data.Number2;
            this.formReadyEvent.dynamicFormService.updateFieldValue(FieldPropertyEnum.Number2, syncedFault.data.Number2);
          }
        }
      });

    this.faultsSyncService.onFaultSynced
      .pipe(untilDestroyed(this))
      .subscribe(async syncedFault => {
        if (syncedFault?.uid && this?.faultData?.UniqueId && syncedFault.uid === this?.faultData?.UniqueId) {
          if (syncedFault.data.Number2 !== this.faultData.Number2) {
            this.faultData.Number2 = syncedFault.data.Number2;
            this.formReadyEvent.dynamicFormService.updateFieldValue(FieldPropertyEnum.Number2, syncedFault.data.Number2);
          }
        }
      });
  }

  private onFaultLoadingSubject = new BehaviorSubject<boolean>(false);
  public onFaultLoading = this.onFaultLoadingSubject.asObservable();

  formConfig$ = new BehaviorSubject<DynamicFormConfig>({fields: [], layouts: []} as DynamicFormConfig);
  formReadyEvent: DynamicFormReadyEvent;
  structureControl: UntypedFormControl = new UntypedFormControl();

  subscriptions: Subscription[] = [];
  sourceSubscriptions: Subscription[] = [];
  structureSubscription: Subscription;

  onFormInitialized = new EventEmitter();
  valueChanged = new Subject();


  permissionEditCtNumber$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.EditCtNumber]);
  permissionEditAssignedStructureOfFault$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.EditAssignedStructureOfFault]);

  faultData: FaultData;
  fault: ViewFault;
  fieldGroups: FaultFieldGroups;
  formControlsDict: { [prop: string]: any } = {};

  allFields: { [name: string]: FaultField } = {};
  permittedFields: FaultField[];
  fieldConfigs: { [name: string]: FieldConfig<string> } = {};
  fieldConfigsDict: { [prop: string]: FaultFieldConfig } = {};

  memoryValues: { [prop: string]: any } = {};
  memoryValuesLoaded = false;

  private loadedStructures: { id: number, text: string, data: any }[];

  isDisabledSubject = new BehaviorSubject<boolean>(false);
  isDisabled$ = this.isDisabledSubject.asObservable();

  // MMW-2309: wrong focus on ios devices
  preventTempFormFocusForIos = false;

  //  Map to store the relationship between field keys and their IDs (used in get pintext value )
  private fieldKeyToIdMap = new Map<string, number>();

  faultFieldValidators: { [prop: string]: ValidatorFn } = {};
  number2Validator: ValidatorFn;
  isValidatingNumber2 = false;

  private addFaultToActivePools = false;
  private activePoolsForAddition: Pool[] = [];
  private shouldShowSuccessToast = new Map<string, boolean>();
  private shouldHideFaultFromView = new Map<string, boolean>();
  private pendingPoolAddition: { fault: ViewFault, pools: Pool[] } | null = null;

  async ngOnInit() {
  }

  public showLoader(currentFault: ViewFault): void {

    if (currentFault?.id !== this.fault?.id && currentFault.loadState.status !== LoadStatusEnum.Loaded) {
      // console.warn('showLoader', this.fault, currentFault);
      this.onFaultLoadingSubject.next(true);
    }
    // else {
    //   console.warn('NO showLoader', this.fault, currentFault);
    // }
  }

  async setFieldDataSource<T>(source: MmModel<T>, fieldProperties: FieldPropertyEnum[]) {
    // await setTimeout(async () => {

    if (source.loadState.status === LoadStatusEnum.Loaded) {
      await fieldProperties.forEach(async prp => {
        if (this.allFields.hasOwnProperty(prp)) {
          const fieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(prp) as FilterSelectFieldConfig;
          if (fieldConfig) {
            fieldConfig.source = await this.faultFieldService.getFieldSource(this.allFields[prp]);
            this.formReadyEvent.dynamicFormService.updateFieldConfig(fieldConfig);
            // console.info(`field config source updated '${prp}': length ${fieldConfig.source?.length ?? 0}`);
          } else {
            // console.info('(1) field config source not set: ' + prp);
          }
        } else {
          // console.info('(0) field config source not set: ' + prp);
        }
      });
    }

    // }, 5000);
  }

  ngOnDestroy() {
  }

  public async setDisabled(isDisabled: boolean) {
    this.isDisabledSubject.next(isDisabled);

    if (this.formReadyEvent?.dynamicFormService) {
      const form: UntypedFormGroup = this.formReadyEvent.dynamicFormService.getFormValue();
      if (this.isDisabledSubject.value) {
        form.disable({emitEvent: false});
      } else {
        form.enable({emitEvent: false});
      }
    }
  }

  public async initialize(fieldsModel: MmModel<FieldMinimal[]>, fieldConfigs: FaultFieldConfig[]) {
    // console.warn('MmFaultDetailsService.initialize.0');

    if (fieldsModel.data && fieldsModel.data.length !== 0) {
      // console.warn('MmFaultDetailsService.initialize.1');

      try {
        this.fieldGroups = this.faultFormService.getFaultFieldGroups(fieldsModel.data);

        clearDictionary(this.fieldConfigsDict);
        clearDictionary(this.allFields);

        for (const f of fieldConfigs.filter(x => x.Visibility === true)) {
          this.fieldConfigsDict[f.Field.Prop] = f;
        }

        // console.warn('MmFaultDetailsService.initialize.2')
        // console.warn(this.fieldGroups);

        const fieldsInternal = [...this.fieldGroups.descriptionFields.concat(this.fieldGroups.executionFields, this.fieldGroups.responsibleFields, this.fieldGroups.classificationFields, this.fieldGroups.projectFields, this.fieldGroups.costFields)];
        this.permittedFields = fieldsInternal.filter(x => (x.Permission === FieldPermission.Write || x.Permission === FieldPermission.Mandatory));
        let sortedFields: FaultField[];

        if (this.fieldConfigsDict && (Object.keys(this.fieldConfigsDict)?.length ?? 0) > 0) {
          sortedFields = fieldsInternal.filter(f => this.fieldConfigsDict.hasOwnProperty(f.Prop) && this.fieldConfigsDict[f.Prop].Visibility === true).sort((a, b) => this.fieldConfigsDict[a.Prop].SortId - this.fieldConfigsDict[b.Prop].SortId);
        } else {
          sortedFields = fieldsInternal;
        }

        for (const f of sortedFields) {
          if (f.Prop === FieldPropertyEnum.ContactCO || f.Prop === FieldPropertyEnum.ContactCT || f.Prop === FieldPropertyEnum.ContactSC) {
            const groupField = JSON.parse(JSON.stringify(f.GroupFields[0]));
            groupField.Prop = f.Prop + '_Company';
            groupField.Name = groupField.Project ?? groupField.Global;
            groupField.Type = f.Type;
            groupField.Permission = f.Permission;

            this.allFields[groupField.Prop] = groupField;
          }
          else if (f.Prop === FieldPropertyEnum.Class1 || f.Prop === FieldPropertyEnum.Class2 || f.Prop === FieldPropertyEnum.Class3 || f.Prop === FieldPropertyEnum.Class4) {
              const groupField = JSON.parse(JSON.stringify(f.GroupFields[0]));
              groupField.Prop = f.Prop;
              groupField.Name = groupField.Project ?? groupField.Global;
              groupField.Type = f.Type;
              groupField.Permission = f.Permission;

              this.allFields[groupField.Prop] = groupField;
            // console.warn('MmFaultDetailsService.initialize.3.1 ' + groupField.Prop)
            // console.warn(groupField);
          } else if (f.Prop === FieldPropertyEnum.Attribute) {
            const attributeGroupField = fieldsModel.data.find(x => x.Id == 'AttributeGroup_Image');
            if (attributeGroupField) {
              const groupField = JSON.parse(JSON.stringify(attributeGroupField));
              groupField.Prop = f.Prop + 'Group_Image';
              groupField.Name = groupField.Project ?? groupField.Global;
              groupField.Type = f.Type;
              groupField.Permission = f.Permission;

              this.allFields[groupField.Prop] = groupField;
            }

            // console.warn('MmFaultDetailsService.initialize.3.1 ' + groupField.Prop)
            // console.warn(groupField);
          }

          if (f.Prop !== FieldPropertyEnum.Class1 && f.Prop !== FieldPropertyEnum.Class2 && f.Prop !== FieldPropertyEnum.Class3 && f.Prop !== FieldPropertyEnum.Class4) {
            this.allFields[f.Prop] = f;
          }

          // console.warn('MmFaultDetailsService.initialize.3.2 ' + f.Prop)
          // console.warn(f);
        }

        // console.warn('MmFaultDetailsService.initialize.4')
        // console.warn(this.allFields);
        // console.warn(this.fieldGroups);

        if (this.fieldGroups) {
          // console.warn('MmFaultDetailsService.initialize.5')
          // console.warn(Object.values(this.allFields));
          // console.warn(this.faultFieldService);


          const noDataSourceFields = [FieldPropertyEnum.ContactCO, FieldPropertyEnum.ContactCT, FieldPropertyEnum.ContactSC,
            FieldPropertyEnum.ContactCO + '_Company', FieldPropertyEnum.ContactCT + '_Company', FieldPropertyEnum.ContactSC + '_Company',
            FieldPropertyEnum.Company, FieldPropertyEnum.Craft, FieldPropertyEnum.Order,
            FieldPropertyEnum.CostsCompany, FieldPropertyEnum.CostsOrder, FieldPropertyEnum.AttributeGroup_Image];

          const hasPermissionEditFaults = await firstValueFrom(this.faultFormService.permissionEditFaults$);
          const formConfigs = await this.faultFieldService.getFieldConfigs(Object.values(this.allFields), this.fieldConfigsDict, noDataSourceFields, true, hasPermissionEditFaults, () => this.openStructureSelection(), true);

          // console.warn('MmFaultDetailsService.initialize.6')
          // console.warn(formConfigs);

          for (const formConfig of formConfigs) {
            this.fieldConfigs[formConfig.name] = formConfig;
          }

          const structureFieldConfig = this.fieldConfigs[FieldPropertyEnum.Structure];
          const structureField = this.allFields[FieldPropertyEnum.Structure];

          await this.setFieldReadonlyState(structureField, structureFieldConfig, false, false);

          // console.warn('MmFaultDetailsService.initialize.7')
          // console.warn(this.fieldConfigs);

          const detailFormConfig: DynamicFormConfig = {
            fields: formConfigs,
            layouts: []
          };

          // console.warn(detailFormConfig);

          // ONLY FOR TESTING PURPOSES
          // await new Promise(f => setTimeout(f, 2000));

          // console.warn(detailFormConfig);

          this.formConfig$.next(detailFormConfig);
        }
        this.initializeFieldKeyToIdMap();
      } catch (err) {
        this.logger.error(err, '', 'MmFaultDetailsService');
      }
    }
  }

  // Method to initialize the Map with key and id pairs from allFields
  private initializeFieldKeyToIdMap() {
    for (const [key, field] of Object.entries(this.allFields)) {
      this.fieldKeyToIdMap.set(key, field.FieldId);
    }
  }

  public clearFault() {
    this.faultData = undefined;
    this.fault = undefined;
  }

  // pendingLoadFault: ViewFault;
  public async loadFault(fault: ViewFault, forceReload: boolean) {
    if (!this.formReadyEvent?.dynamicFormService) {
      this.logger.error('MmFaultDetailsService.NOT_INITIALIZED!!', '', 'MmFaultDetailsService');
      // this.pendingLoadFault = fault;
      return;
    }

    if (!fault) {
      return;
    }

    this.onFaultLoadingSubject.next(true);

    const isNewFault = fault?.id === undefined;
    const newFaultVisibility = await this.getDefaultValueVisible(isNewFault);

    if (isNewFault) {
      try {
        const filterState = await firstValueFrom(this.filterService.state);
        const activeInclusionPools = filterState?.poolInclusionFilters;
        if (activeInclusionPools && activeInclusionPools.length > 0) {
          const hasPoolPermissions = await firstValueFrom(this.permissionService.permissionDefectPoolsAddDefects$);
          if (!hasPoolPermissions && fault?.uid) {
            this.shouldHideFaultFromView.set(fault.uid, true);
          }
        }
      } catch {}
    }

    if (isNewFault || !this.fault || this.fault.uid !== fault.uid) {
      this.addFaultToActivePools = false;
      this.activePoolsForAddition = [];
      this.pendingPoolAddition = null;
    }

    if (!this.faultData || this.faultData.Id !== fault.data.Id || isNewFault || forceReload) {
      this.faultData = JSON.parse(JSON.stringify(fault.data));
    }

    this.fault = fault;
    this.faultFieldService.currentFault = this.faultData;
    this.memoryValuesLoaded = false;

    this.memoryValues = await this.faultFieldMemoryService.getMemoryValues(this.fieldConfigsDict);

    this.removeSubscriptions();

    this.contactServiceCO.preInitialize();
    this.contactServiceCT.preInitialize();
    this.contactServiceSC.preInitialize();
    this.attributeService.preInitialize();

    clearDictionary(this.formControlsDict);
    Object.keys(this.formReadyEvent.dynamicFormService.getFormValue().controls).forEach(key => {
      this.formControlsDict[key] = this.formReadyEvent.dynamicFormService.getFormValue().controls[key];

      if ((this.allFields[key]?.Type == FaultFieldTypeEnum.Text || this.allFields[key]?.Type == FaultFieldTypeEnum.TextArea) && this.formControlsDict[key]?.hasValidator(Validators.required)) {
        this.formControlsDict[key].addValidators(CustomRequiredValidator.required);
      }
    });

    await this.companyService.preInitialize();
    await this.craftService.preInitialize();
    await this.orderService.preInitialize();

    this.companyDependencyService.selectedCompanySubject.next({
      value: (this.fieldExists(FieldPropertyEnum.Company) ? {id: this.getFieldValue(FieldPropertyEnum.Company, FaultFieldTypeEnum.Selection, isNewFault), text: ''} : null),
      sender: NotificationSenderEnum.initialize
    });
    this.companyDependencyService.selectedCraftSubject.next({
      value: (this.fieldExists(FieldPropertyEnum.Craft) ? {id: this.getFieldValue(FieldPropertyEnum.Craft, FaultFieldTypeEnum.Selection, isNewFault), text: ''} : null),
      sender: NotificationSenderEnum.initialize
    });
    this.companyDependencyService.selectedOrderSubject.next({
      value: (this.fieldExists(FieldPropertyEnum.Order) ? {id: this.getFieldValue(FieldPropertyEnum.Order, FaultFieldTypeEnum.Selection, isNewFault), text: ''} : null),
      sender: NotificationSenderEnum.initialize
    });
    if (this.fieldExists(FieldPropertyEnum.Company)) {
      this.companyService.companyInfoMessageSubject.next(null);
      await this.setCompanyInfoDependencies(null);
    }

    if (this.fieldExists(FieldPropertyEnum.Craft)) {
      this.craftService.craftInfoMessageSubject.next(null);
      await this.setCraftInfoDependencies(null);
    }

    if (this.fieldExists(FieldPropertyEnum.Order)) {
      this.orderService.orderInfoMessageSubject.next(null);
      await this.setOrderInfoDependencies(null);
    }

    const isLocked = ((this.fault?.loadState?.data?.IsLocked ?? this.fault?.isLocked) ?? false);
    await this.setDisabled(isLocked);

    if (this.fieldGroups) {
      for (const field of Object.values(this.allFields)) {
        if (this.fieldConfigs.hasOwnProperty(field.Prop) && this.fieldExists(field.Prop)) {
          const fieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(field.Prop);

          await this.setFieldReadonlyState(field, fieldConfig, true, isNewFault);

          if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.filterSelect) {

            if (field.Prop === FieldPropertyEnum.CostsCompany || field.Prop === FieldPropertyEnum.CostsOrder) {
              const selectFieldConfig = fieldConfig as FilterSelectFieldConfig;
              selectFieldConfig.source = await this.faultFieldService.getFieldSource(field);
              this.formReadyEvent.dynamicFormService.updateFieldConfig(selectFieldConfig);
            }

            this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, this.getFieldValue(field.Prop, field.Type, isNewFault));
            this.resetFieldState(field.Prop);

            // variant with filter-select control
            // if (field.Type === FaultFieldTypeEnum.Structure) {
            //   this.structureControl.setValue(this.faultData[field.Prop].Id);
            //     this.structureValueChangesSubscription = this.structureControl.valueChanges
            //       .pipe(untilDestroyed(this))
            //       .subscribe((structureId: number) => {
            //         if (structureId) {
            //           this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, structureId);
            //         }
            //       });
            // }
          } else {
            if (field.Type === FaultFieldTypeEnum.Structure) {

              // const test = await firstValueFrom(this.projectLoaderService.structures.pipe(filter(x => x.loadState.status === LoadStatusEnum.Loaded),
              //   map(st => flattenStructure(st.data).find(f => f.Id === this.memoryValues[FieldPropertyEnum.Structure]?.Id) ))
              // );

              const projectStructure: { [Id: number]: Structure } = {};

              (await firstValueFrom(this.projectLoaderService.structures.pipe(filter(x => x.loadState.status === LoadStatusEnum.Loaded), map(st => flattenStructure(st.data)))))
                .forEach(st => {
                  if (!projectStructure.hasOwnProperty(st.Id)) {
                    projectStructure[st.Id] = st;
                  }
                });

              const memoryStructure = (this.memoryValues && this.memoryValues.hasOwnProperty(FieldPropertyEnum.Structure) && projectStructure.hasOwnProperty(this.memoryValues[FieldPropertyEnum.Structure]?.Id) ? projectStructure[this.memoryValues[FieldPropertyEnum.Structure]?.Id] : null);

              const currentParams = await firstValueFrom(this.mmViewService.currentProject$
                .pipe(untilDestroyed(this),
                  switchMap(project => this.plansManagerService.selectedPlan$.pipe(
                    switchMap(plan =>
                      this.filterService.state.pipe(
                        map(filter => ({plan, currentProject: project, currentStructure: filter.structure, memoryStructure, memoryValue: (this.memoryValues && this.memoryValues.hasOwnProperty(FieldPropertyEnum.Structure) ? this.memoryValues[FieldPropertyEnum.Structure] : null)}))
                      )
                    ))
                  )
                ));

              let newFaultStructure = '';
              let newFaultStructureId: number = null;

              const currentPlanStructure = projectStructure[currentParams.plan?.data?.Structure.Id];

              if (isNewFault && (this.planEditService.planEditMode == PlanEditModeEnum.Edit || this.bimDialogService.IsOpen())) {
                if (currentParams.memoryValue) {
                  if (currentPlanStructure?.Low < currentParams.memoryStructure?.Low && currentPlanStructure?.High > currentParams.memoryStructure?.High) {
                    newFaultStructure = '01 currentParams.memoryValue';
                    newFaultStructureId = currentParams.memoryStructure.Id;
                  } else if (!!currentPlanStructure?.Id) {
                    newFaultStructure = '02 currentParams.plan.data.Structure.Id';
                    newFaultStructureId = currentPlanStructure.Id;
                  } else {
                    newFaultStructure = '02a currentParams.currentStructure';
                    newFaultStructureId = currentParams.currentStructure.Id;
                  }
                } else {
                  if (!currentPlanStructure || (currentPlanStructure?.Low < currentParams.currentStructure?.Low && currentPlanStructure?.High > currentParams.currentStructure?.High)) {
                    newFaultStructure = '03a currentParams.currentStructure';
                    newFaultStructureId = currentParams.currentStructure.Id;
                  } else {
                    newFaultStructure = '03b currentParams.plan.data.Structure.Id';
                    newFaultStructureId = currentPlanStructure.Id;
                  }
                }
              } else if (isNewFault && this.planEditService.planEditMode == PlanEditModeEnum.None) {
                if (currentParams?.currentProject?.Structure?.Id !== currentParams?.currentStructure?.Id) {
                  if (currentParams.memoryValue) {
                    if (currentParams.currentStructure.Low < currentParams.memoryStructure?.Low && currentParams.currentStructure.High > currentParams.memoryStructure?.High) {
                      newFaultStructure = '04 currentParams.memoryValue';
                      newFaultStructureId = currentParams.memoryStructure?.Id;
                    } else {
                      newFaultStructure = '05 currentParams.currentStructure.Id';
                      newFaultStructureId = currentParams.currentStructure.Id;
                    }
                  } else {
                    newFaultStructure = '06 currentParams.currentStructure.Id';
                    newFaultStructureId = currentParams.currentStructure.Id;
                  }
                } else {
                  if (currentParams.memoryValue) {
                    newFaultStructure = '07 currentParams.memoryValue';
                    newFaultStructureId = currentParams.memoryStructure?.Id;
                  } else {
                    newFaultStructure = '08 currentParams.currentProject.Structure.Id';
                    newFaultStructureId = currentParams.currentProject.Structure.Id;
                  }
                }

              }

              if (!this.faultData) {
                return;
              }

              this.setStructureText(field.Prop, (newFaultStructureId ?? this.faultData[field.Prop]?.Id));
              this.faultData[field.Prop] = {Id: (newFaultStructureId ?? this.faultData[field.Prop]?.Id)};

              this.structureControl.setValue(this.faultData[field.Prop]?.Id);
              this.subscriptions.push(this.structureControl.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe((structureId: number) => {
                  this.setStructureText(field.Prop, structureId);
                }));
            } else {
              if (field.Prop === FieldPropertyEnum.IsVisibleForCO && newFaultVisibility) {
                this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, this.getFieldValue(field.Prop, field.Type, isNewFault, newFaultVisibility.IsVisibleCO));
                this.resetFieldState(field.Prop);
              } else if (field.Prop === FieldPropertyEnum.IsVisibleForCT && newFaultVisibility) {
                this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, this.getFieldValue(field.Prop, field.Type, isNewFault, newFaultVisibility.IsVisibleCT));
                this.resetFieldState(field.Prop);
              } else {
                this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, this.getFieldValue(field.Prop, field.Type, isNewFault));
                this.resetFieldState(field.Prop);
              }
            }
          }
        }
      }

      const companyFieldConfig = (this.fieldExists(FieldPropertyEnum.Company) ? this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Company) as FilterSelectFieldConfig : null);
      const companyField = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.Company);

      const craftFieldConfig = (this.fieldExists(FieldPropertyEnum.Craft) ? this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Craft) as FilterSelectFieldConfig : null);
      const craftField = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.Craft);

      const orderFieldConfig = (this.fieldExists(FieldPropertyEnum.Order) ? this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Order) as FilterSelectFieldConfig : null);
      const orderField = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.Order);

      if (!this.faultData || !this.fault?.uid) {
        return;
      }

      if (this.fieldExists(FieldPropertyEnum.Company)) {
        await this.companyService.initialize(fault.data, companyField, this.fieldExists(FieldPropertyEnum.Craft), this.fieldExists(FieldPropertyEnum.Order), companyFieldConfig, this.formReadyEvent);
      }
      if (this.fieldExists(FieldPropertyEnum.Craft)) {
        await this.craftService.initialize(craftField, this.fieldExists(FieldPropertyEnum.Company), this.fieldExists(FieldPropertyEnum.Order), craftFieldConfig, this.formReadyEvent);
      }
      if (this.fieldExists(FieldPropertyEnum.Order)) {
        await this.orderService.initialize(fault.data, orderField, this.fieldExists(FieldPropertyEnum.Company), this.fieldExists(FieldPropertyEnum.Craft), orderFieldConfig, this.formReadyEvent);
      }

      const fieldAttribute = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.Attribute);
      const fieldAttributeGroup = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.AttributeGroup_Image);
      if (this.fieldExists(FieldPropertyEnum.Attribute)) {
        if (!this.faultData || !this.fault?.uid) {
          return;
        }
        await this.attributeService.initialize(this.fault, FieldPropertyEnum.Attribute, fieldAttribute, fieldAttributeGroup, this.formReadyEvent);
      }

      if (!this.faultData || !this.fault?.uid) {
        return;
      }
      await this.initializeContactServices();

      if (!this.faultData || !this.fault?.uid) {
        return;
      }

      this.subscriptions.push(this.companyService.companyInfoMessage$
        .pipe(untilDestroyed(this))
        .subscribe(async message => {
          if (!this.faultData || !this.fault?.uid) {
            return;
          }
          await this.setCompanyInfoDependencies(message);
        }));

      this.subscriptions.push(this.craftService.craftInfoMessage$
        .pipe(untilDestroyed(this))
        .subscribe(async message => {
          if (!this.faultData || !this.fault?.uid) {
            return;
          }
          await this.setCraftInfoDependencies(message);
        }));

      this.subscriptions.push(this.orderService.orderInfoMessage$
        .pipe(untilDestroyed(this))
        .subscribe(async message => {
          if (!this.faultData || !this.fault?.uid) {
            return;
          }
          await this.setOrderInfoDependencies(message);
        }));

      if (this.memoryValuesLoaded) {
        this.commit();
      }
    }

    if (!this.faultData || !this.fault?.uid) {
      return;
    }

    this.subscriptions.push(this.companyDependencyService.onFieldValueChanged
      .pipe(untilDestroyed(this))
      .subscribe(async (params) => {
        if (!this.faultData || !this.fault?.uid) {
          return;
        }
        this.commit();
      }));

    this.subscriptions.push(this.formReadyEvent.dynamicFormEventsService.onFieldValueChanged
      .pipe(untilDestroyed(this))
      .subscribe(async (param: { config: FieldConfig<any>, value: any }) => {
        if (!this.faultData || !this.fault?.uid) {
          return;
        }

        if (param.config.name === FieldPropertyEnum.Number2 && !this.isValidatingNumber2) {
          this.isValidatingNumber2 = true;
          const control: UntypedFormControl = this.formReadyEvent.dynamicFormService.getFormValue().controls[FieldPropertyEnum.Number2] as UntypedFormControl;
          control.markAsTouched();
          control.updateValueAndValidity();
          this.isValidatingNumber2 = false;
        }

        this.commit();
      }));
    this.onFaultLoadingSubject.next(false);

    if (!this.faultData || !this.fault?.uid) {
      return;
    }
    await this.checkPendingPoolAddition();
  }

  resetFieldState(prop: string) {
    this.formControlsDict[prop].markAsPristine();
    this.formControlsDict[prop].markAsUntouched();
    this.formControlsDict[prop].updateValueAndValidity();
  }

  removeSubscriptions() {
    this.subscriptions?.forEach(s => {
      s.unsubscribe();
    });
    this.subscriptions = [];
  }

  removeSourceSubscriptions() {
    this.sourceSubscriptions?.forEach(s => {
      s.unsubscribe();
    });
    this.sourceSubscriptions = [];
  }

  getFieldValue(prop: string, type: FaultFieldTypeEnum, isNewFault: boolean, presetValue?: any) {
    if (isNewFault && !this.faultData[prop] && this.memoryValues?.hasOwnProperty(prop)) {
      this.memoryValuesLoaded = true;
      return this.memoryValues[prop];
    } else {
      if (presetValue) {
        return presetValue;
      } else if (type === FaultFieldTypeEnum.Selection) {
        return this.faultData?.[prop]?.Id;
      }
      return this.faultData?.[prop];
    }
  }

  async setFieldReadonlyState(field: FaultField, fieldConfig: any, updateConfig: boolean, isNewFault: boolean) {

    let isReadonly = false;
    let fieldClass: string;
    let hint: FieldHint;
    let changed = false;

    const hasPermissionEditFaults = await firstValueFrom(this.faultFormService.permissionEditFaults$);

    if (field.Prop === FieldPropertyEnum.Structure) {
      const hasEditAssignedStructureOfFaultPermission = await this.permissionEditAssignedStructureOfFault$.pipe(take(1)).toPromise();
      const isLocked = ((this.fault?.loadState?.data?.IsLocked ?? this.fault?.isLocked) ?? false);
      isReadonly = true;
      const memoryClass = (this.fieldConfigsDict.hasOwnProperty(field.Prop) && this.fieldConfigsDict[field.Prop]?.Memory == true ? 'memory-field' : '');
      fieldClass = ((hasEditAssignedStructureOfFaultPermission && hasPermissionEditFaults) ? `mydocma-ignore-readonly${' ' + memoryClass}` : null);

      if (fieldConfig.suffix.readonly != (!hasEditAssignedStructureOfFaultPermission || !hasPermissionEditFaults || isLocked)) {
        changed = true;
        fieldConfig.suffix.readonly = (!hasEditAssignedStructureOfFaultPermission || !hasPermissionEditFaults || isLocked);
      }
    } else if (field.Prop === FieldPropertyEnum.Number2) {
      const hasEditCtNumberPermission = await this.permissionEditCtNumber$.pipe(take(1)).toPromise();
      isReadonly = !(field.Permission === FieldPermission.Write || field.Permission === FieldPermission.Mandatory) || (!hasEditCtNumberPermission && !isNewFault) || !hasPermissionEditFaults;
      const memoryClass = (this.fieldConfigsDict.hasOwnProperty(field.Prop) && this.fieldConfigsDict[field.Prop]?.Memory == true ? 'memory-field' : '');

      // console.warn('5097 - hasEditCtNumberPermission', hasEditCtNumberPermission);
      // console.warn('5097 - isNewFault', isNewFault);

      fieldClass = ((hasEditCtNumberPermission || isNewFault) && !isReadonly ? `mydocma-ignore-readonly${' ' + memoryClass}` : memoryClass);
      if (!isReadonly){
        hint =  {
          text: 'MM.fault.number2hint',
          icon: {
            iconName: '_info',
            outlined: true
          },
          class: 'number2-info-message'
        } as FieldHint;
      }
    } else {
      // const isLocked = ((this.fault?.loadState?.data?.IsLocked ?? this.fault?.isLocked) ?? false);
      // isReadonly = (isLocked ? true : !(field.Permission === FieldPermission.Write || field.Permission === FieldPermission.Mandatory));
      isReadonly = !(field.Permission === FieldPermission.Write || field.Permission === FieldPermission.Mandatory) || !hasPermissionEditFaults;
    }

    if (fieldConfig.readonly !== isReadonly) {
      fieldConfig.readonly = isReadonly;
      changed = true;
    }

    if (fieldClass && fieldConfig.class !== fieldClass) {
      fieldConfig.class = fieldClass;
      changed = true;
    }

    if (fieldClass && fieldConfig.hint !== hint) {
      fieldConfig.hint = hint;
      changed = true;
    }

    if (updateConfig && changed) {
      this.formReadyEvent.dynamicFormService.updateFieldConfig(fieldConfig);
    }
  }

  async initializeContactServices() {
    const fieldContactCO = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactCO);
    const fieldContactCompanyCO = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactCO + '_Company');
    if (this.fieldExists(FieldPropertyEnum.ContactCO)) {
      await this.contactServiceCO.initialize(FieldPropertyEnum.ContactCO, fieldContactCO, fieldContactCompanyCO, this.formReadyEvent);
    }


    const fieldContactCT = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactCT);
    const fieldContactCompanyCT = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactCT + '_Company');
    if (this.fieldExists(FieldPropertyEnum.ContactCT)) {
      await this.contactServiceCT.initialize(FieldPropertyEnum.ContactCT, fieldContactCompanyCT, fieldContactCompanyCT, this.formReadyEvent);
    }

    const fieldContactSC = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactSC);
    const fieldContactCompanySC = Object.values(this.allFields).find(f => f.Prop === FieldPropertyEnum.ContactSC + '_Company');
    if (this.fieldExists(FieldPropertyEnum.ContactSC)) {
      await this.contactServiceSC.initialize(FieldPropertyEnum.ContactSC, fieldContactSC, fieldContactCompanySC, this.formReadyEvent);
    }
  }

  commit() {
    let changed = false;

    const hiddenFields = this.permittedFields.filter(x => Object.values(this.allFields).findIndex(y => y.Prop === x.Prop) === -1);
    const changedFields = Object.values(this.allFields).concat(hiddenFields);

    if (this.fieldGroups && this.faultData) {
      for (const field of changedFields) {


        if (this.fieldConfigs.hasOwnProperty(field.Prop) && this.fieldExists(field.Prop)) {
          if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.filterSelect) {
            const currentValue = this.formReadyEvent.dynamicFormService.getFieldValue(field.Prop);
            if (currentValue != this.faultData[field.Prop]?.Id) {
              this.faultData[field.Prop] = (currentValue ? {Id: currentValue} : null);
              changed = true;

              if (field.Prop === FieldPropertyEnum.Company && this.companyDependencyService.selectedCompanySubject.value?.value?.id !== this.faultData[field.Prop]?.Id) {
                this.companyDependencyService.selectedCompanySubject.next({
                  value: (this.faultData[field.Prop] ? {
                    id: this.faultData[field.Prop].Id,
                    text: ''
                  } : null), sender: NotificationSenderEnum.company
                });
              } else if (field.Prop === FieldPropertyEnum.Craft && this.companyDependencyService.selectedCraftSubject.value?.value?.id !== this.faultData[field.Prop]?.Id) {
                this.companyDependencyService.selectedCraftSubject.next({
                  value: (this.faultData[field.Prop] ? {
                    id: this.faultData[field.Prop].Id,
                    text: ''
                  } : null), sender: NotificationSenderEnum.craft
                });
              } else if (field.Prop === FieldPropertyEnum.Order && this.companyDependencyService.selectedOrderSubject.value?.value?.id !== this.faultData[field.Prop]?.Id) {
                this.companyDependencyService.selectedOrderSubject.next({
                  value: (this.faultData[field.Prop] ? {
                    id: this.faultData[field.Prop].Id,
                    text: ''
                  } : null), sender: NotificationSenderEnum.order
                });
              }
            }
          } else {
            if (field.Type === FaultFieldTypeEnum.Structure) {
              const currentValue = this.structureControl.value;
              if (currentValue != this.faultData[field.Prop]?.Id && currentValue) {
                this.faultData[field.Prop] = {Id: currentValue};
                changed = true;
              }
            } else {
              const currentValue = this.formReadyEvent.dynamicFormService.getFieldValue(field.Prop);

              if (field.Prop == FieldPropertyEnum.Date1 || field.Prop == FieldPropertyEnum.Date2 || field.Prop == FieldPropertyEnum.Date3) {
                let currentDateValue = (currentValue ? moment(currentValue).utcOffset(0, true).format() : null);
                currentDateValue = (currentDateValue && currentDateValue.lastIndexOf('Z') != -1 ? currentDateValue.slice(0, currentDateValue.lastIndexOf('Z')) : currentDateValue);
                if (currentDateValue != this.faultData[field.Prop]) {
                  this.faultData[field.Prop] = currentDateValue;
                  changed = true;
                }
              } else {
                if (currentValue != this.faultData[field.Prop] && field.Prop !== FieldPropertyEnum.Number1) {
                  this.faultData[field.Prop] = currentValue;
                  changed = true;
                }
              }
            }
          }
        }
      }

      if (changed) {
        this.valueChanged.next(null);
      }
    }
  }


  public validate(): boolean {
    return this.formReadyEvent.dynamicFormValidationService.validate();
  }

  public async hasChanges() {
    let hasChanges = false;

    const hiddenFields = this.permittedFields.filter(x => Object.values(this.allFields).findIndex(y => y.Prop === x.Prop) === -1);
    const changedFields = Object.values(this.allFields).concat(hiddenFields);

    if (this.fieldGroups) {
      for (const field of changedFields) {
        if (this.fieldConfigs.hasOwnProperty(field.Prop)) {
          if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.filterSelect) {
            if (this.fault.data[field.Prop]?.Id != this.faultData[field.Prop]?.Id && ['ContactCO_Company', 'ContactCT_Company', 'ContactSC_Company', 'AttributeGroup_Image'].every(x => x !== field.Prop)) {
              hasChanges = true;
              break;
            }
          } else if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.slidetoggle) {
            if ((this.fault.data[field.Prop] ?? false) != (this.faultData[field.Prop] ?? false)) {
              hasChanges = true;
              break;
            }
          } else {
            if (field.Type === FaultFieldTypeEnum.Structure) {
              if (this.fault.data[field.Prop]?.Id != this.faultData[field.Prop]?.Id) {
                hasChanges = true;
                break;
              }
            } else {
              if (this.fault.data[field.Prop] != this.faultData[field.Prop]) {
                hasChanges = true;
                break;
              }
            }
          }
        }
      }
    }

    return hasChanges;
  }

  public async getChanges(): Promise<FaultData> {
    this.trimWhitespaceChars();

    const hiddenFields = this.permittedFields.filter(x => Object.values(this.allFields).findIndex(y => y.Prop === x.Prop) === -1);
    const changedFields = Object.values(this.allFields).concat(hiddenFields)
      .filter(x => this.fieldService.groupFields.findIndex(f => f === x.Id) === -1);

    const changes = new FaultData();
    let hasChanges = false;
    const changedMemoryValues: { [prop: string]: any } = {};
    const isNewFault = this.fault?.id === undefined;

    if (this.fieldGroups) {
      for (const field of changedFields) {
        if (this.fieldConfigs.hasOwnProperty(field.Prop)) {
          if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.filterSelect) {
            // const currentValue = this.formReadyEvent.dynamicFormService.getFieldValue(field.Prop);
            if (this.fault.data[field.Prop]?.Id != this.faultData[field.Prop]?.Id && [FieldPropertyEnum.ContactCO_Company, FieldPropertyEnum.ContactCT_Company, FieldPropertyEnum.ContactSC_Company].every(x => x !== field.Prop)) {
              changes[field.Prop] = this.faultData[field.Prop];
              changedMemoryValues[field.Prop] = this.faultData[field.Prop]?.Id;
              hasChanges = true;

              if (field.Prop === FieldPropertyEnum.Company && this.faultData[field.Prop]?.Id) {
                await this.companyDependencyService.saveRecentlyUsedEntities(this.faultData[field.Prop]?.Id, PersonalizationKeysEnum.RecentlyUsedCompanies);
                await this.companyService.reloadCompanies();
              } else if (field.Prop === FieldPropertyEnum.Craft && this.faultData[field.Prop]?.Id) {
                await this.companyDependencyService.saveRecentlyUsedEntities(this.faultData[field.Prop]?.Id, PersonalizationKeysEnum.RecentlyUsedCrafts);
                await this.craftService.reloadCrafts();
              } else if (field.Prop === FieldPropertyEnum.Order && this.faultData[field.Prop]?.Id) {
                await this.companyDependencyService.saveRecentlyUsedEntities(this.faultData[field.Prop]?.Id, PersonalizationKeysEnum.RecentlyUsedOrders);
                await this.orderService.reloadOrders();
              }
            }
          } else if (this.fieldConfigs[field.Prop].type === FieldTypeEnum.slidetoggle) {
            if (this.fault.data[field.Prop] !== this.faultData[field.Prop] && this.faultData[field.Prop] != null) {
              changes[field.Prop] = (this.faultData[field.Prop] ?? false);
              changedMemoryValues[field.Prop] = (this.faultData[field.Prop] ?? false);
              hasChanges = true;
            }
          } else {
            if (field.Prop === FieldPropertyEnum.Structure) {
              if (this.fault.data[field.Prop]?.Id !== this.faultData[field.Prop]?.Id) {
                changes[field.Prop] = this.faultData[field.Prop];
                changedMemoryValues[field.Prop] = this.faultData[field.Prop];
                hasChanges = true;
              }
            } else {
              if (this.fault.data[field.Prop] !== this.faultData[field.Prop]) {
                changes[field.Prop] = this.faultData[field.Prop];
                changedMemoryValues[field.Prop] = this.faultData[field.Prop];
                hasChanges = true;
              }
            }
          }
        }
      }

      if (hasChanges) {
        await this.faultFieldMemoryService.saveMemoryValues(changedMemoryValues, this.fieldConfigsDict);
      }

      if (isNewFault) {
        await this.checkAndShowPoolAdditionDialog();
      }

      if (hasChanges) {
        return changes;
      }
    }

    return null;
  }


  private async checkAndShowPoolAdditionDialog(): Promise<void> {
    try {

      const filterState = await firstValueFrom(this.filterService.state);
      const activeInclusionPools = filterState?.poolInclusionFilters;


      if (!activeInclusionPools || activeInclusionPools.length === 0) {
        return;
      }

      const hasPoolPermissions = await firstValueFrom(this.permissionService.permissionDefectPoolsAddDefects$);

      if (!hasPoolPermissions) {
        console.warn('checkAndShowPoolAdditionDialog: No pool permissions, returning early');
        this.shouldHideFaultFromView.set(this.fault?.uid, true);
        this.shouldShowSuccessToast.set(this.fault?.uid, true);
        return;
      }

      const isMultiplePools = activeInclusionPools.length > 1;


      const title = isMultiplePools
        ? this.translateService.instant('MM.pool.listToggle.addToPoolsDialog.title')
        : this.translateService.instant('MM.pool.listToggle.addToPoolDialog.title');

      const content = isMultiplePools
        ? this.translateService.instant('MM.pool.listToggle.addToPoolsDialog.content')
        : this.translateService.instant('MM.pool.listToggle.addToPoolDialog.content');

      const result = await this.dialogService.showPromptDialog({
        title,
        content,
        buttons: [
          {
            text: this.translateService.instant('MM.general.button.no'),
            type: MydocmaPromptButtonTypeEnum.default,
            value: false
          },
          {
            text: this.translateService.instant('MM.general.button.yes'),
            type: MydocmaPromptButtonTypeEnum.primary,
            value: true
          }
        ]
      });

      if (result?.value) {
        this.addFaultToActivePools = true;
        this.activePoolsForAddition = activeInclusionPools;
        this.shouldHideFaultFromView.delete(this.fault?.uid);
      } else {
        this.shouldShowSuccessToast.set(this.fault?.uid, true);
        this.shouldHideFaultFromView.set(this.fault?.uid, true);
      }
    } catch (error) {
      this.logger.error(error, '', 'MmFaultDetailsService');
    }
  }

  public async handlePoolAdditionAfterSave(fault: ViewFault): Promise<void> {


    if (this.addFaultToActivePools && this.activePoolsForAddition?.length > 0) {
      if (fault?.id) {
        try {
          await this.addFaultToPoolsInternal(fault, this.activePoolsForAddition);
          this.addFaultToActivePools = false;
          this.activePoolsForAddition = [];
          this.shouldHideFaultFromView.delete(this.fault?.uid);
        } catch (error) {
          this.logger.error(error, '', 'MmFaultDetailsService');
          this.notificationService.error(
            this.translateService.instant('MM.pool.listToggle.errorAddingFaultPools')
          );
        }
      } else {
        this.pendingPoolAddition = {fault, pools: [...this.activePoolsForAddition]};
        this.addFaultToActivePools = false;
        this.activePoolsForAddition = [];
        this.shouldHideFaultFromView.delete(this.fault?.uid);
      }
    }

    if (this.shouldShowSuccessToast.get(this.fault?.uid)) {

      this.notificationService.info(
        this.translateService.instant('MM.fault.creation.successWithoutPoolFiltered')
      );
      this.shouldShowSuccessToast.delete(this.fault?.uid);

      if (this.shouldHideFaultFromView.get(this.fault?.uid) && fault) {
        this.triggerFaultsRefresh(fault);
      } else {
        this.shouldHideFaultFromView.delete(this.fault?.uid);
      }
    }
  }

  private async addFaultToPoolsInternal(fault: ViewFault, pools: Pool[]): Promise<void> {
    const currentProject = await firstValueFrom(this.mmProjectService.currentProject);
    if (!currentProject) {
      return;
    }

    const defect = {
      Id: fault.id,
      SUid: fault.data.SUid,
      UniqueId: fault.uid
    };

    for (const pool of pools) {
      try {
        await firstValueFrom(this.poolApiService.addDefectsToPool(currentProject.Id, pool.Id, [defect]));
      } catch (error) {
        this.logger.error(error, '', 'MmFaultDetailsService');
        throw error;
      }
    }

    this.poolFaultTracker.trackAdded([fault.id], pools.map(p => p.Id));

    const poolCountChanges = pools.map(p => ({poolId: p.Id, countChange: 1}));
    this.faultsLoaderService.emitPoolCountUpdated(poolCountChanges);
  }


  public shouldFaultBeHiddenFromView(fault?: ViewFault): boolean {
    const faultToCheck = fault || this.fault;

    const isCurrentFault = this.fault && faultToCheck && this.fault.uid === faultToCheck.uid;
    const shouldHide = isCurrentFault && this.shouldHideFaultFromView.get(faultToCheck.uid);

    return shouldHide;
  }


  private triggerFaultsRefresh(faultToHide: ViewFault): void {
    if (faultToHide) {
      this.faultsLoaderService.mmFaultsCountService.decreaseVisibleNewFaults(1);
      this.faultsLoaderService.removeFaultFromView(faultToHide);
    }
  }

  public async checkPendingPoolAddition(newFault?: ViewFault): Promise<void> {


    if (newFault && this.pendingPoolAddition && this.pendingPoolAddition.fault?.uid === newFault.uid && newFault.id) {
      try {
        await this.addFaultToPoolsInternal(newFault, this.pendingPoolAddition.pools);
        this.pendingPoolAddition = null;
        this.shouldHideFaultFromView.delete(this.fault?.uid);
      } catch (error) {
        this.logger.error(error, '', 'MmFaultDetailsService');
        this.notificationService.error(
          this.translateService.instant('MM.pool.listToggle.errorAddingFaultPools')
        );
        this.pendingPoolAddition = null;
      }
      return;
    }

    if (this.pendingPoolAddition && this.pendingPoolAddition.fault?.id) {
      try {
        await this.addFaultToPoolsInternal(this.pendingPoolAddition.fault, this.pendingPoolAddition.pools);
        this.pendingPoolAddition = null;
        this.shouldHideFaultFromView.delete(this.fault?.uid);
      } catch (error) {
        this.logger.error(error, '', 'MmFaultDetailsService');
        this.notificationService.error(
          this.translateService.instant('MM.pool.listToggle.errorAddingFaultPools')
        );
        this.pendingPoolAddition = null;
      }
    }
  }

  trimWhitespaceChars() {
    if (this.fieldGroups) {
      for (const field of Object.values(this.allFields)) {
        if (field.Permission === FieldPermission.None || field.Permission === FieldPermission.Read) {
          continue;
        }

        const fieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(field.Prop);
        const fieldValue = this.formReadyEvent.dynamicFormService.getFieldValue(field.Prop);

        const isTextField = this.faultFieldService.fieldSettings.hasOwnProperty(field.Prop) && (this.faultFieldService.fieldSettings[field.Prop].fieldType === FaultFieldTypeEnum.Text || this.faultFieldService.fieldSettings[field.Prop].fieldType === FaultFieldTypeEnum.TextArea);

        if (fieldValue && isTextField) {
          if (field && typeof fieldValue === 'string') {
            const cleanedValue = fieldValue?.trimLeft()?.trimRight();
            if (cleanedValue !== fieldValue) {
              this.formReadyEvent.dynamicFormService.updateFieldValue(field.Prop, cleanedValue);
            }
          }
        }
      }
    }
  }

  public setStructure(structureId: number) {
    if (structureId) {
      // variant with filter-select control
      // this.formReadyEvent.dynamicFormService.updateFieldValue(FieldDefaultNameEnum.Structure, this.faultData[FieldDefaultNameEnum.Structure]?.Id);

      this.setStructureText(FieldDefaultNameEnum.Structure, structureId);
      this.structureControl.setValue(structureId);
    }
  }

  private setStructureText(prop: string, structureId?: number) {
    if (!structureId) {
      this.formReadyEvent.dynamicFormService.updateFieldValue(prop, '');
    } else {
      const found = this.loadedStructures.find(x => x.id === structureId);
      if (found) {
        this.formReadyEvent.dynamicFormService.updateFieldValue(prop, found.text);
        const structurePathConfig = this.formReadyEvent.dynamicFormService.getFieldConfig('StructurePath');
        structurePathConfig.label.text = `${this.allFields[FieldPropertyEnum.Structure].Name} ${this.translateService.instant('MM.fault.structurePathSuffix')}`;
        this.formReadyEvent.dynamicFormService.updateFieldConfig(structurePathConfig);
        this.formReadyEvent.dynamicFormService.updateFieldValue('StructurePath', found.data);
      } else {
        this.formReadyEvent.dynamicFormService.updateFieldValue(prop, `Structure id ${structureId} not found!`);
      }
    }
  }

  async openStructureSelection() {
    const hasEditAssignedStructureOfFaultPermission = await this.permissionEditAssignedStructureOfFault$.pipe(take(1)).toPromise();
    const hasPermissionEditFaults = await firstValueFrom(this.faultFormService.permissionEditFaults$);
    const isLocked = ((this.fault?.loadState?.data?.IsLocked ?? this.fault?.isLocked) ?? false);

    if (hasEditAssignedStructureOfFaultPermission && hasPermissionEditFaults && !isLocked) {
      if (this.planEditService.planEditMode === PlanEditModeEnum.Edit || this.bimDialogService.IsOpen()) {
        this.viewService.requestToggleView(FaultViewEnum.SelectFaultStructure,
          {
            structure: this.faultData.Structure?.Id, structureControl: this.structureControl,
            planId: this.plansManagerService.selectedPlan?.id
          });
      } else {
        this.viewService.requestToggleView(FaultViewEnum.SelectFaultStructure,
          {
            structure: this.faultData.Structure?.Id, structureControl: this.structureControl,
            planId: this.faultData.PlanId || this.fault?.bpPin?.Locations?.find(l => l.Type == BpPinLocationTargetEnum.plan)?.ModelId
          });
      }
    }
  }

  public async onFormReady(event: DynamicFormReadyEvent) {
    this.formReadyEvent = event;

    this.removeSourceSubscriptions();

    this.sourceSubscriptions.push(this.projectLoaderService.classifications
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        // console.warn('setFieldDataSource OF Classifications');
        // console.warn(source);
        await this.setFieldDataSource<Classifications>(source, [FieldPropertyEnum.Class1, FieldPropertyEnum.Class2, FieldPropertyEnum.Class3, FieldPropertyEnum.Class4]);
      }));

    this.sourceSubscriptions.push(this.projectLoaderService.crafts
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        await this.setFieldDataSource<Craft[]>(source, [FieldPropertyEnum.Craft]);
      }));

    this.sourceSubscriptions.push(this.projectLoaderService.orders
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        await this.setFieldDataSource<Order[]>(source, [FieldPropertyEnum.Order, FieldPropertyEnum.CostsOrder]);
      }));

    this.sourceSubscriptions.push(this.projectLoaderService.companies
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        await this.setFieldDataSource<Company[]>(source, [FieldPropertyEnum.Company, FieldPropertyEnum.CostsCompany]);
      }));

    this.sourceSubscriptions.push(this.projectLoaderService.userDefineds
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        await this.setFieldDataSource<UserDefineds>(source, [FieldPropertyEnum.UserDefined1, FieldPropertyEnum.UserDefined2]);
      }));

    this.sourceSubscriptions.push(this.projectLoaderService.structures
      .pipe(untilDestroyed(this))
      .subscribe(async source => {
        await this.setFieldDataSource<Structure[]>(source, [FieldPropertyEnum.Structure]);
      }));

    if (this.structureSubscription) {
      this.structureSubscription.unsubscribe();
    }

    this.structureSubscription = this.formReadyEvent.dynamicFormEventsService.onControlClick
      .pipe(untilDestroyed(this))
      .subscribe((fieldConfig: FieldConfig<string>) => {
        if (fieldConfig.name === FieldDefaultNameEnum.Structure) {
          // console.warn('onControlClick.openStructureSelection');
          this.openStructureSelection();
        }
      });

    const control: UntypedFormControl = this.formReadyEvent.dynamicFormService.getFormValue().controls[FieldPropertyEnum.Number2] as UntypedFormControl;
    if (control) {
      this.number2Validator = CustomNumber2Validator(undefined, FieldPropertyEnum.Number2, this.formReadyEvent.dynamicFormService, this.translateService);
      this.formReadyEvent.dynamicFormService.updateFieldConfig({
        name: FieldPropertyEnum.Number2,
        validators: [this.number2Validator]
      } as any);
    }

    this.onFormInitialized.emit();

    // if (this.pendingLoadFault) {
    //   // console.warn('PENDING LOAD FAULT CASE!!!');
    //   this.loadFault(this.pendingLoadFault);
    //   this.pendingLoadFault = null;
    // }
  }


  async validateFields(syncStateChange?: SyncStateChange) {
    let isNewFault = this.fault?.id === undefined;

    if (this.fieldGroups) {
      for (const field of Object.values(this.allFields)) {
        const control: UntypedFormControl = this.formReadyEvent.dynamicFormService.getFormValue().controls[field.Prop] as UntypedFormControl;
        const state = (syncStateChange.syncState ?? this.fault?.syncState);

        if (!this.fault?.id && syncStateChange.faultId && this.fault.uid === syncStateChange.faultUid) {
          this.fault.id = syncStateChange.faultId;
          isNewFault = this.fault?.id === undefined;
        }

        if (field.Id == FieldPropertyEnum.Number2) {
          const fieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(field.Prop);
          await this.setFieldReadonlyState(field, fieldConfig, true, isNewFault);
        }

        if (state?.error && ValidateFieldErrorBySyncState(control, state, this.faultData[field.Prop], field.Prop, field.Id, this.errorService) != null) {
          if (this.faultFieldValidators[field.Prop]) {
            control.removeValidators(this.faultFieldValidators[field.Prop]);
            delete this.faultFieldValidators[field.Prop];
          }
          this.faultFieldValidators[field.Prop] = CustomFieldBySyncStateValidator(state, this.faultData[field.Prop], field.Prop, field.Id, this.errorService);
          control.addValidators(this.faultFieldValidators[field.Prop]);

          control.markAsTouched();
          control.updateValueAndValidity();
        } else if (!state?.error && this.faultFieldValidators[field.Prop]) {
          control.removeValidators(this.faultFieldValidators[field.Prop]);
          delete this.faultFieldValidators[field.Prop];
        }
      }
    }
  }

  async getDefaultValueVisible(isNewFault: boolean): Promise<{ IsVisibleCO: boolean, IsVisibleCT: boolean }> {
    if (isNewFault) {

      const projectUserPerms = await this.projectLoaderService.projectUserPermissions.pipe(filter(m => m.loadState.status === LoadStatusEnum.Loaded),
        first()).toPromise();
      const projectSettings = await this.projectLoaderService.projectSettings.pipe(filter(m => m.loadState.status === LoadStatusEnum.Loaded),
        first()).toPromise();
      let IsVisibleForCO;
      let IsVisibleForCT;

      if (projectUserPerms?.data?.User?.Company?.ViewPoint === ViewPoint.Contractor) {
        IsVisibleForCO = projectSettings?.data?.find(s => s.Key === 'DefaultVisibilityANAN')?.Setting;
        IsVisibleForCT = projectSettings?.data?.find(s => s.Key === 'DefaultVisibilityANAG')?.Setting;
      } else if (projectUserPerms?.data?.User?.Company?.ViewPoint === ViewPoint.Customer) {
        IsVisibleForCO = projectSettings?.data?.find(s => s.Key === 'DefaultVisibilityAGAN')?.Setting;
        IsVisibleForCT = projectSettings?.data?.find(s => s.Key === 'DefaultVisibilityAGAG')?.Setting;
      }

      let isVisibleForCO: boolean;
      let isVisibleForCT: boolean;

      if (this.fieldGroups?.responsibleFields?.find(p => p.Id === 'IsVisibleForCO')) {
        isVisibleForCO = IsVisibleForCO === 'True' ? true : false;
      }
      if (this.fieldGroups?.responsibleFields?.find(p => p.Id === 'IsVisibleForCT')) {
        isVisibleForCT = IsVisibleForCT === 'True' ? true : false;
      }

      return Promise.resolve({IsVisibleCO: isVisibleForCO, IsVisibleCT: isVisibleForCT});
    }
  }

  fieldExists(prop: string) {
    return this.allFields.hasOwnProperty(prop) && this.formControlsDict.hasOwnProperty(prop);
    // return this.allFields.hasOwnProperty(prop) && this.formReadyEvent.dynamicFormService.getFormValue().controls.hasOwnProperty(prop);
  }

  async setCompanyInfoDependencies(notMatchingWith: FaultDependencyEnum[]) {
    if (this.fieldExists(FieldPropertyEnum.Company)) {
      const companyConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Company);
      if (notMatchingWith) {
        const secondFieldText = getSecondFieldText(notMatchingWith, this.formReadyEvent);
        companyConfig.hint = {
          text: this.translateService.instant('MM.fault.dependencyInfoMessage', {firstField: companyConfig.label.text, secondField: secondFieldText}),
          icon: {
            iconName: '_info',
            outlined: true
          },
          class: 'dependency-info-message'
        } as FieldHint;
      } else {
        companyConfig.hint = null;
      }

      this.formReadyEvent.dynamicFormService.updateFieldConfig(companyConfig);
    }
  }

  async setCraftInfoDependencies(notMatchingWith: FaultDependencyEnum[]) {
    if (this.fieldExists(FieldPropertyEnum.Craft)) {
      const craftConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Craft);
      if (notMatchingWith) {
        const secondFieldText = getSecondFieldText(notMatchingWith, this.formReadyEvent);
        craftConfig.hint = {
          text: this.translateService.instant('MM.fault.dependencyInfoMessage', {firstField: craftConfig.label.text, secondField: secondFieldText}),
          icon: {
            iconName: '_info',
            outlined: true
          },
          class: 'dependency-info-message'
        } as FieldHint;
      } else {
        craftConfig.hint = null;
      }

      this.formReadyEvent.dynamicFormService.updateFieldConfig(craftConfig);
    }
  }

  async setOrderInfoDependencies(notMatchingWith: FaultDependencyEnum[]) {
    if (this.fieldExists(FieldPropertyEnum.Order)) {
      const orderConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(FieldPropertyEnum.Order);
      if (notMatchingWith) {
        const secondFieldText = getSecondFieldText(notMatchingWith, this.formReadyEvent);

        orderConfig.hint = {
          text: this.translateService.instant('MM.fault.dependencyInfoMessage', {firstField: orderConfig.label.text, secondField: secondFieldText}),
          icon: {
            iconName: '_info',
            outlined: true
          },
          class: 'dependency-info-message'
        } as FieldHint;
      } else {
        orderConfig.hint = null;
      }
      this.formReadyEvent.dynamicFormService.updateFieldConfig(orderConfig);
    }
  }

  async updateInfoMessageConfig(prop: string) {
    const fieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(prop) as FilterSelectFieldConfig;
    fieldConfig.source.forEach(item => {
      if (item.items && (item.items?.length ?? 0) > 0 && item.data && typeof item.data === 'string') {
        item.text = this.translateService.instant(item.data);
      } else if (item.items && (item.items?.length ?? 0) > 0 && item.data && typeof item.data === 'function') {
        item.text = item.data();
      }
    });
    this.formReadyEvent.dynamicFormService.updateFieldConfig(fieldConfig);
  }

  async discardChanges() {
  }
}

export abstract class CustomRequiredValidator extends Validators {
  public static override required({value}: AbstractControl): ValidationErrors | null {
    return String(value ?? '').trim() ? null : {required: true};
  }
}

export function CustomFieldBySyncStateValidator(syncState: SyncState, data: any, prop: string, defaultName: string, errorService: ErrorService): CustomValidatorFn {
  return (control: AbstractControl): CustomValidationError | null => {
    return ValidateFieldErrorBySyncState(control, syncState, data, prop, defaultName, errorService);
  };
}

export function ValidateFieldErrorBySyncState(control: AbstractControl, syncState: SyncState, data: any, prop: string, defaultName: string, errorService: ErrorService) {
  if (syncState?.error) {
    // console.warn('CreateSyncStateFieldValidator ' + prop);
    const e = errorService.getError(syncState?.error);
    if ((e?.InternalErrors?.length ?? 0) > 0) {
      if (e?.InternalErrors) {
        for (const internalError of e.InternalErrors) {
          if ((internalError.Prop === prop || internalError.Prop === defaultName) && control.value === data) {
            // if (fieldName) {
            //   internalError.Message = internalError.Message.replaceAll(`'${prop}'`, `'${fieldName}'`);
            // }
            return {mydocmaCustomError: internalError.Message} as CustomValidationError;
          }
        }
      }
    }
  }
  return null;
}

export function CustomNumber2Validator(data: any, prop: string, dynamicFormService: DynamicFormService, translateService: TranslateService): CustomValidatorFn {
  return (control: AbstractControl): CustomValidationError | null => {
    return ValidateNumber2(control, data, prop, dynamicFormService, translateService);
  };
}

export function ValidateNumber2(control: AbstractControl, data: any, prop: string, dynamicFormService: DynamicFormService, translateService: TranslateService) {
  const value = control.value?.trimLeft()?.trimRight();

  if (value && typeof value === 'string' && (value.match(/#/g) || []).length > 1) {
    dynamicFormService.updateFieldConfig({name: FieldPropertyEnum.Number2, hint: undefined});
    return {mydocmaCustomError: 'MM.fault.number2errorOnlyOne#'};
  }
  // else if (value && typeof value === 'string' && (value.match(/#/g) || []).length === 1 && /[0-9]/.test(value)) {
  //   dynamicFormService.updateFieldConfig({name: FieldPropertyEnum.Number2, hint: undefined});
  //   return {mydocmaCustomError: 'MM.fault.number2errorNoNumbers'};
  // }
  else if (value && typeof value === 'string' && (value.match(/#/g) || []).length === 1) {
    const [prefix, suffix] = value.split('#');
    if (prefix.length > 16 || suffix.length > 16) {
      dynamicFormService.updateFieldConfig({name: FieldPropertyEnum.Number2, hint: undefined});
      return {mydocmaCustomError: 'MM.fault.number2errorPrefixSuffixLength'};
    }
  }
  return null;
}

export function getSecondFieldText(notMatchingWith: FaultDependencyEnum[], form: DynamicFormReadyEvent) {
  let messageText = null;

  if (notMatchingWith && notMatchingWith?.length === 1) {
    messageText = form.dynamicFormService.getFieldConfig(notMatchingWith[0]).label.text;
  } else if (notMatchingWith) {
    messageText = form.dynamicFormService.getFieldConfig(notMatchingWith[0]).label.text
      + ', ' + form.dynamicFormService.getFieldConfig(notMatchingWith[1]).label.text;
  }
  return messageText;
}
